import { Col, Row } from "antd";
import type { FC } from "react";

import SwapIcon from "../../assets/transaction-history/swap.svg";
import { useLanguageContext } from "../../contexts/language/language";
import { ViewHeader } from "..";

interface SwapLayoutProps {
  children?: React.ReactNode;
}

export const SwapLayout: FC<SwapLayoutProps> = ({ children }) => {
  const {
    currentLanguageData: { common },
  } = useLanguageContext();

  return (
    <Row>
      <Col span={24}>
        <ViewHeader textAlign="center">
          <img src={SwapIcon} alt="" width={23} height={26} style={{ marginRight: 20, marginBottom: 5 }} />
          {common.swap}
        </ViewHeader>
        {children}
      </Col>
    </Row>
  );
};
